
import { defineComponent, PropType } from 'vue'
import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'
export default defineComponent({
  name: 'Impact',
  components: {
    ZIcon
  },
  props: {
    score: {
      type: Number,
      required: true
    },
    texts: {
      type: Object as PropType<{ [key: number]: string }>,
      required: true
    }
  },
  computed: {
    icon() {
      switch (this.score) {
        case 1:
          return 'safety-safe'
        case 2:
          return 'safety-caution'
        case 3:
          return 'safety-unsafe'
        default:
          return ''
      }
    },
    iconColor() {
      switch (this.score) {
        case 1:
          // This creates text-juniper-10 class. Do not remove this comment.  Colors break. FML!
          return 'juniper-10'
        case 2:
          return 'honey'
        case 3:
          return 'cherry'
        default:
          return 'gray-500'
      }
    },
    text() {
      return this.texts[this.score] || ''
    }
  }
})
